import { EPaymentMethod } from '../types/payment'

export interface IPaymentMethod {
	id: EPaymentMethod
	// brand name shown as is, or an i18n key when the name is translated
	name?: string
	nameKey?: string
	gtmLabel: string
	// logos on the payment method picker
	selectLogos: string[]
	// logos on the booking summary (thank you page)
	summaryLogos: string[]
}

// order = order on the payment method picker
export const PAYMENT_METHODS: IPaymentMethod[] = [
	{
		id: EPaymentMethod.ONLINE,
		nameKey: 'modules.reservation_module.reservation.payment.online_payment',
		gtmLabel: 'online',
		selectLogos: ['ing-logo.png', 'pko-logo.png', 'mbank-logo.png', 'others'],
		summaryLogos: ['tpay-logo.png'],
	},
	{
		id: EPaymentMethod.BLIK,
		name: 'BLIK',
		gtmLabel: 'blik',
		selectLogos: ['blik-logo.png'],
		summaryLogos: ['blik-logo.png'],
	},
	{
		id: EPaymentMethod.APPLE_PAY,
		name: 'Apple Pay',
		gtmLabel: 'apple_pay',
		selectLogos: ['apple-pay-logo.png'],
		summaryLogos: ['apple-pay-logo.png'],
	},
	{
		id: EPaymentMethod.GOOGLE_PAY,
		name: 'Google Pay',
		gtmLabel: 'google_pay',
		selectLogos: ['google-pay-logo.png'],
		summaryLogos: ['google-pay-logo.png'],
	},
]
